<script setup lang="ts">
defineProps({
  object: Object|null,
  avatar: String,
})
</script>

<template>
  <UPageCard class="w-full h-80 h-80 hover:ring-gray-300 hover:dark:ring-gray-700 hover:shadow-lg hover:bg-white" :ui="{header: 'bg-primary h-20 w-full p-4 sm:p-6 rounded-t-lg', container: () => 'w-full flex flex-col', wrapper: 'min-h-0', body: 'relative flex flex-col flex-1 gap-x-8 gap-y-4 p-4 sm:p-6 gap-2 w-full min-h-0'}">
    <template #header>
      <div class="squircle p-1 bg-white size-22">
        <UAvatar class="rounded-none squircle w-full h-full size-20" :src="avatar ?? '/im/organization-avatar-default.png'" alt=""></UAvatar>
      </div>
    </template>
    <template #body>
      <slot name="body" />
    </template>
  </UPageCard>
</template>